var _defs, _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgKaddexWhite = function SvgKaddexWhite(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 158.278,
    height: 24,
    viewBox: "0 0 158.278 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1001.669 -93.483)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1001.669 93.483)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 3.192,
    height: 23.607,
    transform: "translate(0 0.148)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1037.584,93.807h-4.322l-10.653,10.279h-4.128v3.3h4.332l10.45,10.082h4.322L1025.6,105.9v-.534Z",
    transform: "translate(-1013.373 -93.709)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1101.436,93.483h-3.487l.024.049-11.761,23.7h3.438L1099.692,97l8.6,17.339H1095v2.9h18.17l-11.762-23.7Z",
    transform: "translate(-1060.528 -93.483)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1192.455,93.645h-12.081v3.29h12.081a8.563,8.563,0,0,1,0,17.124h-8.889V100.5h-3.192v16.85h12.081a11.854,11.854,0,0,0,0-23.7Z",
    transform: "translate(-1126.083 -93.596)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1280.958,93.645h-12.081v3.29h12.081a8.563,8.563,0,0,1,0,17.124h-8.889V100.5h-3.192v16.85h12.081a11.854,11.854,0,0,0,0-23.7Z",
    transform: "translate(-1187.7 -93.596)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1358.522,94.293h-.736v13.279H1371v-3.246h-9.969V97.539H1381.6V94.293h-23.081Z",
    transform: "translate(-1249.598 -94.047)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1361.026,146.1h-3.241v8.016H1381.6v-3.246h-20.576Z",
    transform: "translate(-1249.598 -130.112)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1446.024,93.969h-4.371l9.871,11.678-10.166,12.027h4.371l7.98-9.441,7.98,9.441h4.371Z",
    transform: "translate(-1307.782 -93.821)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1495.6,93.969h-4.371l-7.019,8.3,2.186,2.585Z",
    transform: "translate(-1337.614 -93.821)"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgKaddexWhite, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/KADDEX-white.be1c810d.svg";
export { ForwardRef as ReactComponent };